/* ••[1]••••••••••••••••••••••••• TestimonialVideo.ts •••••••••••••••••••••••••••••• */

type TestimonialVideo = {
  durationInMinutes: number;
  link: string;
  thumbnail: string;
  title: string;
};

function validatedTestimonialVideo(
  testimonialVideo: TestimonialVideo
): TestimonialVideo | null {
  if (
    "durationInMinutes" in testimonialVideo &&
    typeof testimonialVideo.durationInMinutes === "number" &&
    "link" in testimonialVideo &&
    typeof testimonialVideo.link === "string" &&
    "thumbnail" in testimonialVideo &&
    typeof testimonialVideo.thumbnail === "string" &&
    "title" in testimonialVideo &&
    typeof testimonialVideo.title === "string"
  ) {
    return testimonialVideo;
  }

  return null;
}

export { TestimonialVideo, validatedTestimonialVideo };
